import { property } from 'lodash-es';
import { compose } from 'redux';
import { SESSION_HEADERS } from '../../constants';
import { pick } from '../utils';

export const current = state => ({ ...state.session });

export const id = compose(
  property('id'),
  current
);

export const isSignedIn = compose(
  hasAllAuthTokens,
  current
);

export const userId = compose(
  property('user_id'),
  current
);

export const siteConfigId = compose(
  property('site_config_id'),
  current
);

export const headers = compose(
  pick(SESSION_HEADERS),
  current
);

function hasAllAuthTokens(session) {
  const isTokenInSession = token => !!session[token];
  return !!session && SESSION_HEADERS.every(isTokenInSession);
}
